import React from 'react';
import { Form } from 'antd';
import { buildConditionContext, evaluateCondition } from '../utils/condition';

interface ConditionalFormItemProps {
  condition?: string;
  children: React.ReactNode;
}

// Wrap antd Form.Item children with conditional visibility based on docs/fields `condition`
// Usage: <ConditionalFormItem condition="sub_service == registration"> ... form items ... </ConditionalFormItem>
const ConditionalFormItem: React.FC<ConditionalFormItemProps> = ({ condition, children }) => {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldsValue }) => {
        const values = getFieldsValue(true);
        const ctx = buildConditionContext(values);
        const visible = evaluateCondition(condition, ctx);
        if (!visible) return null;
        return <>{children}</>;
      }}
    </Form.Item>
  );
};

export default ConditionalFormItem;

